module.exports = __webpack_public_path__ + "img/bg_breathetime@2x.a3b26abf.png";